import { useQuery } from '@tanstack/react-query';
import { getAgencyStats } from '../../services/agency-stats/AgencyStatsService';

export const useAgencyStats = (from: Date, to: Date) => {
  return useQuery({
    queryKey: ['agency-stats', from.toISOString(), to.toISOString()],
    queryFn: () => getAgencyStats(from, to),
  });
};
